(function($) {
  'use strict';

  const calculator = {
    dom: function() {
      this.$calculator = $('#calculator');
    },

    calculator: function() {
      if (typeof calculator.$calculator == 'undefined' || calculator.$calculator.length == 0) {
        return;
      }

      $('input[type=text]', calculator.$calculator).on('keyup', function() {
        if ($(this).val().match(/^[A-Za-z]+$/)) {
          $(this).parent().addClass('error');
          return false;
        }

        $(this).parent().removeClass('error');
        $('[data-sum]').each(function() {
          let cellTotal = 0;
          let cell = $(this).data('sum');
          $('[data-cell="' + cell + '"]').each(function(index, element) {
            if ($(element).val().length) {
              cellTotal += parseInt($(element).val());
            }
          });
          $(this).text('$' + cellTotal).data('total', cellTotal);
          let math = cellTotal - $('[data-minus="' + cell + '"]').val();
          $('[data-math="' + cell + '"]').text('$' + math).data('total', math);
        });
      });

      $('[data-minus]', calculator.$calculator).on('keyup', function() {
        let cell = $(this).data('minus');
        let math = $('[data-sum="' + cell + '"]').data('total') - $(this).val();
        $('[data-math="' + cell + '"]').text('$' + math).data('total', math);
      });
    },

    ready: function() {
      this.dom();
      this.calculator();
    }
  };

  $(document).ready(calculator.ready());

})(jQuery);
